import { useTour } from "../contexts/TourContext";
import { HelpCircle } from "lucide-react";

// Floating Help button — shows in the bottom-right of every authenticated
// page. Clicking it starts the universal walkthrough. Hidden when the
// tenant has disabled the onboarding tour in Settings.
export default function TourHelpButton() {
  const { enabled, active, start } = useTour();
  if (!enabled || active) return null;

  return (
    <button
      onClick={start}
      data-testid="tour-help-button"
      title="Start guided tour"
      className="fixed bottom-6 right-6 z-40 inline-flex items-center gap-2 h-12 pl-3 pr-5 rounded-full bg-slate-900 text-white shadow-lg shadow-slate-900/20 hover:bg-rose-500 hover:shadow-rose-500/30 transition-all"
    >
      <span className="w-7 h-7 rounded-full bg-white/15 flex items-center justify-center">
        <HelpCircle className="w-4 h-4" strokeWidth={2} />
      </span>
      <span className="text-sm font-semibold font-['Outfit']">Help / Tour</span>
    </button>
  );
}
